import {FormControl, FormHelperText} from '@mui/material';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import {useField, useFormikContext} from 'formik';
import {getFormFieldLabel} from 'main/utility/LayoutUtil';
import PropTypes from 'prop-types';

const AppStarRating = ({
  name,
  value,
  precision = 0.5,
  max = 5,
  readonly = false,
  ...props
}) => {
  const [field, meta] = useField(name);
  const {setFieldValue} = useFormikContext();

  const errorText = meta.error && meta.touched ? meta.error : '';
  const ratingValue = parseFloat(field.value ?? value) || 0;

  const handleChange = !readonly
    ? (_, newValue) => setFieldValue(name, newValue ?? 0)
    : undefined;

  return (
    <FormControl error={!!errorText} fullWidth sx={{mt: 0}}>
      {getFormFieldLabel(props)}
      <Box>
        <Rating
          name={name}
          value={ratingValue}
          precision={precision}
          max={max}
          readOnly={readonly}
          onChange={handleChange}
          sx={{py: 1}}
        />
      </Box>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};

AppStarRating.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  precision: PropTypes.number,
  max: PropTypes.number,
  readonly: PropTypes.bool,

  label: PropTypes.string,
  required: PropTypes.bool,
};

export default AppStarRating;
